import React from 'react';

const Copyright = () => {
  return (
    <div className={'copyright-info-group'}>
      <p className={'copyright-info'}>Copyright© Vlending Co. All rights reserved.</p>
    </div>
  );
};

export default Copyright;
